import React, {Fragment} from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {withTranslation} from "react-i18next";

const CalendarDateRangePicker = ({
  t,
  onChangeStartDate,
  onChangeEndDate,
  maxStartDate,
  maxEndDate,
  StartDateTextShow,
  defaultStartDate,
  EndDateTextShow,
  defaultEndDate,
  dateFormat,
  errorShown,
  errorMessage,
}) => {
  const placeHolder = dateFormat.toUpperCase();

  return (
    <Fragment>
      <div className="offset-sm-2 col-sm-4 row">
        <label className="col-form-label col-sm-5 text-lg-right">
          {StartDateTextShow}
        </label>
        <div className="col-sm-7 p-0">
          <DatePicker
            className="form-control"
            allowSameDay
            dateFormat="dd/MM/yyyy"
            maxDate={maxStartDate}
            selected={defaultStartDate}
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            placeholderText={placeHolder}
            onChange={onChangeStartDate}
          />
          <label hidden={!errorShown}>
            <span style={{ color: "red" }}>{errorMessage}</span>
          </label>
        </div>
      </div>
      <div className="col-sm-4 row">
        <label className="col-form-label col-sm-5 text-lg-right">
          {EndDateTextShow}
        </label>
        <div className="col-sm-7 p-0">
          <DatePicker
            className="form-control"
            allowSameDay
            dateFormat="dd/MM/yyyy"
            maxDate={maxEndDate}
            selected={defaultEndDate}
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            placeholderText={placeHolder}
            onChange={onChangeEndDate}
          />
          <label hidden={!errorShown}>
            <span style={{ color: "red" }}>{errorMessage}</span>
          </label>
        </div>
      </div>
    </Fragment>
  );
};

export default withTranslation()(CalendarDateRangePicker);
